import type { SettingEntry } from "./types";

// Source: psyna-cpo product/research/admin-console.md, section V.2 (names and descriptions verbatim;
// careful -> caution, dangerous -> danger; "(fine-tuning)" mark moved to `fineTuning`).
export const SETTINGS = [
  {
    key: "transit_day",
    kind: "llm",
    screen: "texts-ai",
    group: "Daily transit",
    name: "Daily transit: AI model and length",
    risk: "danger",
    description:
      "Дневной разбор на Today, главная статья счёта за ИИ; выключить нельзя, низкий потолок обрезает ответ и пользователь видит шаблонный день, смена модели меняет весь счёт. Сид gpt-4o-mini, 800, поднято до 4000.",
    fineTuning: false,
  },
  {
    key: "transit_history_lines",
    kind: "dial",
    screen: "texts-ai",
    group: "Daily transit",
    name: "Daily transit: past lines shown to AI",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Сколько прошлых строк видит модель; сид 0 (выкл), в описании «вкл: 7»; меняет тексты у всех, строки хранятся в Redis.",
    fineTuning: true,
  },
  {
    key: "transit_lead_fast_bonus",
    kind: "dial",
    screen: "texts-ai",
    group: "Daily transit",
    name: "Daily transit: fast-aspect bonus",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Как выбирается ведущий аспект дня; сид 1.0 (вкл: 1.5); меняет тексты дневного транзита у всех.",
    fineTuning: true,
  },
  {
    key: "transit_lead_repeat_penalty",
    kind: "dial",
    screen: "texts-ai",
    group: "Daily transit",
    name: "Daily transit: repeat penalty",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Штраф за повтор ведущего аспекта; сид 1.0 (вкл: 0.5); меняет тексты у всех.",
    fineTuning: true,
  },
  {
    key: "transit_lead_exact_bonus",
    kind: "dial",
    screen: "texts-ai",
    group: "Daily transit",
    name: "Daily transit: exact-aspect bonus",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Бонус точному аспекту при выборе ведущего; сид 1.0 (вкл: 1.5); меняет тексты у всех.",
    fineTuning: true,
  },
  {
    key: "natal",
    kind: "llm",
    screen: "texts-ai",
    group: "Natal reading",
    name: "Natal reading: AI model and length",
    risk: "caution",
    description:
      "Натальный разбор, один раз после онбординга; сид gpt-4o-mini, 2200; модель и потолок действуют на все новые разборы.",
    fineTuning: false,
  },
  {
    key: "archetype",
    kind: "llm",
    screen: "texts-ai",
    group: "Natal archetype title",
    name: "Natal archetype title: AI model and length",
    risk: "caution",
    description:
      "Заголовок из 3 существительных и абзац около 220 знаков после натала; сид gpt-4o-mini, 400; даёт короткий текст начала пути.",
    fineTuning: false,
  },
  {
    key: "synastry_mini",
    kind: "llm",
    screen: "texts-ai",
    group: "Synastry preview (free)",
    name: "Synastry preview (free): AI model and length",
    risk: "caution",
    description:
      "Бесплатное превью разбора пары; сид gpt-4o-mini, 2400; влияет на бесплатный расход.",
    fineTuning: false,
  },
  {
    key: "synastry_full",
    kind: "llm",
    screen: "texts-ai",
    group: "Synastry (full)",
    name: "Synastry (full): AI model and length",
    risk: "caution",
    description: "Полный разбор пары; сид gpt-4o, 2000; gpt-4o дороже mini.",
    fineTuning: false,
  },
  {
    key: "composite",
    kind: "llm",
    screen: "texts-ai",
    group: "Composite chart",
    name: "Composite chart: AI model and length",
    risk: "caution",
    description:
      "Композитная карта пары; сид gpt-4o, 3500, t=0.70; модель и потолок влияют на цену.",
    fineTuning: false,
  },
  {
    key: "lens",
    kind: "llm",
    screen: "texts-ai",
    group: "Relation lens preview",
    name: "Relation lens preview: AI model and length",
    risk: "caution",
    description: "Превью линзы отношения; сид gpt-4o-mini, 900; влияет на расход.",
    fineTuning: false,
  },
  {
    key: "synastry_lens",
    kind: "llm",
    screen: "texts-ai",
    group: "Lens (paid reading)",
    name: "Lens (paid reading): Synastry AI model",
    risk: "danger",
    description:
      "Платный разбор пары через линзу; выключить нельзя без потери: функция падает без запасного пути; модель задаёт цену платного. Сид gpt-4o-mini 2400, миграцией 089 поставлена gpt-5.6-luna.",
    fineTuning: false,
  },
  {
    key: "partner_day_lens",
    kind: "llm",
    screen: "texts-ai",
    group: "Lens (paid reading)",
    name: "Lens (paid reading): Pair day AI model",
    risk: "caution",
    description:
      "Платный «день пары» через линзу; модель и потолок задают цену платного; миграция 089 ставит gpt-5.6-luna.",
    fineTuning: false,
  },
  {
    key: "partner_day",
    kind: "llm",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: AI model and on/off",
    risk: "danger",
    description:
      "Бесплатный текст «дня пары»; сид gpt-4o-mini, 1400+400; выключить строку значит функция исчезает (ошибка PartnerDayDisabledError).",
    fineTuning: false,
  },
  {
    key: "pair_day_variants",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: variants per answer",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Сколько вариантов пишет модель; сид 3; больше значит дороже и длиннее ответ, 1 = старая форма.",
    fineTuning: true,
  },
  {
    key: "pair_day_history_days",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: days of history checked",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. За сколько дней сравнивать с прошлыми текстами; сид 7; влияет на выбор наименее повторяющегося варианта.",
    fineTuning: true,
  },
  {
    key: "pair_day_repeat_threshold",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: repeat threshold",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Порог похожести, после которого вариант считается повтором; сид 0.6.",
    fineTuning: true,
  },
  {
    key: "pair_day_angle_cooldown_days",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: angle cooldown in days",
    risk: "caution",
    description: "Fine-tuning, usually leave as is. Сколько дней «угол дня» не повторяется; сид 3.",
    fineTuning: true,
  },
  {
    key: "pair_day_custom_angles_max",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: max custom angles",
    risk: "caution",
    description: "Fine-tuning, usually leave as is. Сколько своих «углов» учитывается; сид 3.",
    fineTuning: true,
  },
  {
    key: "partner_day_history_lines",
    kind: "dial",
    screen: "texts-ai",
    group: "Pair day",
    name: "Pair day: past lines shown to AI",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Сколько прошлых строк видит модель; сид 0 (выкл), в описании «вкл: 7»; меняет тексты у всех, строки хранятся в Redis. Code no longer reads this row (DUE-329); removal is wave 2.",
    fineTuning: true,
  },
  {
    key: "relation_angles",
    kind: "llm",
    screen: "texts-ai",
    group: "Relation angles from user words",
    name: "Relation angles from user words: AI on/off",
    risk: "caution",
    description:
      "«Углы» из слов пользователя про отношение; сидится выключенным; включить значит вызов ИИ на каждое новое описание, выкл значит пул названных отношений.",
    fineTuning: false,
  },
  {
    key: "paid_text_rules_lens",
    kind: "dial",
    screen: "texts-ai",
    group: "Style check of paid texts",
    name: "Style check of paid texts: Lens",
    risk: "none",
    description:
      "Проверка стиля платных текстов: `count` пишет нарушения, `off` не проверяет; текст не меняется; сид count; безопасно, но слепнет панель нарушений.",
    fineTuning: false,
  },
  {
    key: "paid_text_rules_synastry_lens",
    kind: "dial",
    screen: "texts-ai",
    group: "Style check of paid texts",
    name: "Style check of paid texts: Synastry lens",
    risk: "none",
    description: "То же для платного разбора пары через линзу.",
    fineTuning: false,
  },
  {
    key: "paid_text_rules_partner_day_lens",
    kind: "dial",
    screen: "texts-ai",
    group: "Style check of paid texts",
    name: "Style check of paid texts: Pair day lens",
    risk: "none",
    description: "То же для платного «дня пары» через линзу.",
    fineTuning: false,
  },
  {
    key: "generation_audit_retention_days",
    kind: "dial",
    screen: "texts-ai",
    group: "Generation log",
    name: "Generation log: days to keep",
    risk: "caution",
    description:
      "Сколько дней хранится непроголосованная запись журнала; сид 90 (7..730); меньше значит теряется материал для разбора качества.",
    fineTuning: false,
  },
  {
    key: "generation_audit_store_prompt",
    kind: "dial",
    screen: "texts-ai",
    group: "Generation log",
    name: "Generation log: save prompts",
    risk: "caution",
    description:
      "Писать ли промпты в журнал (в них дата рождения); сид true; false это выключатель приватности, но тогда не разобрать причины плохих текстов.",
    fineTuning: false,
  },
  {
    key: "partner_day",
    kind: "flag",
    screen: "features",
    group: "Pair day",
    name: "Pair day: on/off",
    risk: "danger",
    description:
      "Главный выключатель «дня пары» на вкладке партнёра; сид выкл, миграция 087 включила для всех; выкл значит вкладка рисует старые строки people[] (функция 1.0).",
    fineTuning: false,
  },
  {
    key: "today_pair_teaser",
    kind: "flag",
    screen: "features",
    group: "Pair day",
    name: "Pair day: nearest-person caption on Today",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Подпись «ближайший человек» на Today, без Pair day подписи нет; миграция 087 включила; выкл значит транзитный тег.",
    fineTuning: true,
  },
  {
    key: "partner_day_share",
    kind: "flag",
    screen: "features",
    group: "Pair day",
    name: "Pair day: Share button",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Кнопка Share под «днём пары»; выкл, в версии 1.0 share нет; включать после дизайна карточки.",
    fineTuning: true,
  },
  {
    key: "partner_day_lens_bond_today",
    kind: "flag",
    screen: "features",
    group: "Pair day",
    name: "Pair day: deep paid lens",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Глубокая платная линза; выкл; включение меняет хеш промпта, кэш линзы пересоберётся, вызов дороже.",
    fineTuning: true,
  },
  {
    key: "reading_feedback_enabled",
    kind: "flag",
    screen: "features",
    group: "Reading ratings",
    name: "Reading ratings: on/off",
    risk: "caution",
    description:
      "Футер «понравился ли разбор»; сид выкл, миграция 086 включила для всех; выкл значит оценок нет.",
    fineTuning: false,
  },
  {
    key: "synastry_lens_plain_words",
    kind: "flag",
    screen: "features",
    group: "Lens (paid reading)",
    name: "Lens (paid reading): plain words only",
    risk: "caution",
    description:
      "Запрет астро-терминов в видимых полях платной линзы; вкл (088); переключение пересоздаёт все линзы, это расход.",
    fineTuning: false,
  },
  {
    key: "transit_moon_rhythm",
    kind: "flag",
    screen: "features",
    group: "Daily transit",
    name: "Daily transit: Moon rhythm",
    risk: "caution",
    description:
      "Луна в 09/15/21 в промпте дневного транзита; выкл; меняет текст у включённых, токенов больше.",
    fineTuning: false,
  },
  {
    key: "web_surface_enabled",
    kind: "flag",
    screen: "features",
    group: "Web app",
    name: "Web app: on/off",
    risk: "danger",
    description: "Главный выключатель всего psyna.app; выкл; включение открывает веб-продукт.",
    fineTuning: false,
  },
  {
    key: "share_links_target_web",
    kind: "flag",
    screen: "features",
    group: "Web",
    name: "Web: share links open the web app",
    risk: "danger",
    description:
      "Fine-tuning, usually leave as is. Ссылки share ведут на веб; включать только после Web app; выкл; до веба ссылки мёртвые.",
    fineTuning: true,
  },
  {
    key: "web_auth_email",
    kind: "flag",
    screen: "features",
    group: "Web sign-in",
    name: "Web sign-in: email",
    risk: "caution",
    description: "Fine-tuning, usually leave as is. Вход на вебе по email; выкл.",
    fineTuning: true,
  },
  {
    key: "web_auth_google",
    kind: "flag",
    screen: "features",
    group: "Web sign-in",
    name: "Web sign-in: Google",
    risk: "caution",
    description: "Fine-tuning, usually leave as is. Вход на вебе через Google; выкл.",
    fineTuning: true,
  },
  {
    key: "web_auth_apple",
    kind: "flag",
    screen: "features",
    group: "Web sign-in",
    name: "Web sign-in: Apple",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Вход через Apple; выкл; требует настройки, иначе вход ломается.",
    fineTuning: true,
  },
  {
    key: "web_auth_telegram",
    kind: "flag",
    screen: "features",
    group: "Web sign-in",
    name: "Web sign-in: Telegram",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Вход через Telegram; выкл; требует настройки, иначе вход ломается.",
    fineTuning: true,
  },
  {
    key: "paywall_entry",
    kind: "flag",
    screen: "features",
    group: "Paywall entry points",
    name: "Paywall entry points",
    risk: "caution",
    description:
      "Точки входа в пейволл на фронте; строки в админке нет (не сидится), нет строки значит точки скрыты; чтобы включить, флаг создают вручную.",
    fineTuning: false,
  },
  {
    key: "natal",
    kind: "free_tier",
    screen: "money",
    group: "Free natal reading",
    name: "Free natal reading",
    risk: "danger",
    description:
      "Натал бесплатен: больше 0 всем, 0 закрывает за пейволл (закрывает вход за деньги); сид 1 [допущение: гость получает натал при регистрации, по -142].",
    fineTuning: false,
  },
  {
    key: "transits_daily_free",
    kind: "free_tier",
    screen: "money",
    group: "Free daily transit",
    name: "Free daily transit",
    risk: "danger",
    description:
      "Дневной транзит бесплатен навсегда (больше 0) или пробный период и тизер (0); сид 1; 0 меняет монетизацию Today.",
    fineTuning: false,
  },
  {
    key: "transit_trial_days",
    kind: "free_tier",
    screen: "money",
    group: "Daily transit trial (days)",
    name: "Daily transit trial (days)",
    risk: "none",
    description:
      "Fine-tuning, usually leave as is. Дней бесплатного транзита, только когда Free daily transit = 0; сид 3; при текущем сиде не действует.",
    fineTuning: true,
  },
  {
    key: "synastry_free_per_day",
    kind: "dial",
    screen: "money",
    group: "Free synastry partners per day",
    name: "Free synastry partners per day",
    risk: "caution",
    description:
      "Сколько новых партнёров с разбором бесплатно в сутки UTC, 0 значит нет; сид 10 (0..200); меньше значит раньше кредиты или подписка, больше значит расход ИИ.",
    fineTuning: false,
  },
  {
    key: "relation_paid_levels_visible",
    kind: "dial",
    screen: "money",
    group: "Relation level",
    name: "Relation level: show paid levels",
    risk: "caution",
    description:
      "Показывать платные уровни отношений ($1.99 / $4.99); сид true; false скрывает платную полосу (влияет на деньги).",
    fineTuning: false,
  },
  {
    key: "relation_edits_per_day",
    kind: "dial",
    screen: "money",
    group: "Relation level",
    name: "Relation level: paid edits per day",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Платных правок уровня отношений в сутки; сид 10 (0..100); 0 блокирует.",
    fineTuning: true,
  },
  {
    key: "partner_day_daily_limit",
    kind: "dial",
    screen: "features",
    group: "Pair day",
    name: "Pair day: readings per person per day",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Разборов «дня пары» на человека в сутки; сид 20 (0..200); 0 выключает функцию.",
    fineTuning: true,
  },
  {
    key: "STARS_USD_RATE",
    kind: "dial",
    screen: "money",
    group: "Telegram Star to USD rate",
    name: "Telegram Star to USD rate",
    risk: "caution",
    description:
      "Курс Star в доллары для экономики (от него зависит выручка на странице Economics, в описании это не сказано); сид 0.013; валидатора нет.",
    fineTuning: false,
  },
  {
    key: "APPSTORE_USD_RATES",
    kind: "dial",
    screen: "money",
    group: "App Store currency rates to USD",
    name: "App Store currency rates to USD",
    risk: "caution",
    description:
      'Курсы валют чека App Store в доллары; сид {"USD": 1}; валюты без курса выпадают из выручки («not converted»); валидатора нет.',
    fineTuning: false,
  },
  {
    key: "web_paywall_mode",
    kind: "dial",
    screen: "money",
    group: "Web paywall mode",
    name: "Web paywall mode",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Веб-пейволл: redirect_app или checkout (зарезервирован); сид redirect_app; checkout пока без кнопки.",
    fineTuning: true,
  },
  {
    key: "app_store_url",
    kind: "dial",
    screen: "money",
    group: "App Store link on web paywall",
    name: "App Store link on web paywall",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Ссылка на iOS на веб-пейволле; сид пусто; пока пусто, ссылка не рисуется.",
    fineTuning: true,
  },
  {
    key: "guest_signups_per_ip_per_day",
    kind: "dial",
    screen: "money",
    group: "New guest sign-ups per IP per day",
    name: "New guest sign-ups per IP per day",
    risk: "danger",
    description:
      "Потолок новых гостей с одного IP в сутки, каждый гость получает один бесплатный натал; сид 20, 0 = без лимита; мало значит люди за NAT/VPN не войдут; влияние на конверсию неизвестно.",
    fineTuning: false,
  },
  {
    key: "web_auth_rate_limit_per_hour",
    kind: "dial",
    screen: "money",
    group: "Sign-in emails per hour",
    name: "Sign-in emails per hour",
    risk: "caution",
    description: "Писем входа в час на email и IP; сид 5 (1..100); мало значит блокирует честных.",
    fineTuning: false,
  },
  {
    key: "people_of_day_count",
    kind: "dial",
    screen: "people",
    group: "People of the day",
    name: "People of the day: how many",
    risk: "caution",
    description: "Сколько партнёров в «людях дня»; сид 3; 0 убирает раздел.",
    fineTuning: false,
  },
  {
    key: "people_of_day_max_orb",
    kind: "dial",
    screen: "people",
    group: "People of the day",
    name: "People of the day: aspect precision",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Насколько точным должен быть аспект; сид 3.0°; это предохранитель.",
    fineTuning: true,
  },
  {
    key: "people_window_half_hours",
    kind: "dial",
    screen: "people",
    group: "People of the day",
    name: "People of the day: time window",
    risk: "caution",
    description: "Fine-tuning, usually leave as is. Ширина окна в часах; сид 1 ч.",
    fineTuning: true,
  },
  {
    key: "teaser_cards_count",
    kind: "dial",
    screen: "people",
    group: "Teaser",
    name: "Teaser: cards shown",
    risk: "none",
    description:
      "Карточек у тизер-пользователя; сид 1; при Free daily transit больше 0 тизера нет [допущение по -124]. Старое слово «non-streaking» в описании устарело.",
    fineTuning: false,
  },
  {
    key: "today_teaser_shows_lead",
    kind: "dial",
    screen: "people",
    group: "Teaser",
    name: "Teaser: show first paragraph of closed day",
    risk: "none",
    description:
      "Fine-tuning, usually leave as is. Отдавать ли закрытому дню абзац-lead; сид true; действует то же допущение, что у предыдущей строки.",
    fineTuning: true,
  },
  {
    key: "today_body_source",
    kind: "dial",
    screen: "people",
    group: "Today",
    name: "Today: which body is shown",
    risk: "caution",
    description:
      "Какое тело рисует сцена Today: featured или weekday; сид featured; действует сразу, кэш 72 ч не ждёт.",
    fineTuning: false,
  },
  {
    key: "transit_week_horizon",
    kind: "dial",
    screen: "people",
    group: "Week strip",
    name: "Week strip: days on each side",
    risk: "caution",
    description:
      "Дней по сторонам в ленте недели; сид 3 (2..7); 7 даёт пустые «призрачные» дни и более тяжёлый ответ.",
    fineTuning: false,
  },
  {
    key: "daily_push_copy_variant",
    kind: "dial",
    screen: "people",
    group: "Daily push",
    name: "Daily push: text variant",
    risk: "caution",
    description:
      "Текст пуша: headline или headline_with_transit; сид headline; меняет текст всех пушей.",
    fineTuning: false,
  },
  {
    key: "push_pause_after_inactive_days",
    kind: "dial",
    screen: "people",
    group: "Push",
    name: "Push: pause after inactive days",
    risk: "caution",
    description:
      "Через сколько дней неактивности пуши ставятся на паузу, 0 не ставить; сид 7; больше значит больше пушей спящим.",
    fineTuning: false,
  },
  {
    key: "language_switcher_locales",
    kind: "dial",
    screen: "people",
    group: "Language switcher",
    name: "Language switcher: offered languages",
    risk: "caution",
    description:
      "Какие языки предлагает переключатель; сид [en, es, pt], русский скрыт; не отнимает язык у тех, у кого он есть; пустой список запрещён.",
    fineTuning: false,
  },
  {
    key: "web_magic_link_ttl_min",
    kind: "dial",
    screen: "people",
    group: "Web sign-in link lifetime (min)",
    name: "Web sign-in link lifetime (min)",
    risk: "none",
    description:
      "Fine-tuning, usually leave as is. Срок жизни ссылки входа; сид 15 мин; только веб.",
    fineTuning: true,
  },
  {
    key: "web_auth_prompt_moment",
    kind: "dial",
    screen: "people",
    group: "Web",
    name: "Web: when to ask «save your access»",
    risk: "none",
    description:
      "Fine-tuning, usually leave as is. Когда звать «сохрани доступ»; сид after_first_chart; только веб.",
    fineTuning: true,
  },
  {
    key: "text_forms_transit",
    kind: "flag",
    screen: "forms",
    group: "Forms for Daily transit",
    name: "Forms for Daily transit: on/off and rollout",
    risk: "caution",
    description:
      "Главный выключатель: дневной транзит из готовых форм вместо ИИ для выбранных языков и процента; сид выкл, правил нет; правило вида `{locale in [es,pt], rollout_percent N}`; не попавшие получают ИИ, английский не затрагивается.",
    fineTuning: false,
  },
  {
    key: "text_forms_partner_day",
    kind: "flag",
    screen: "forms",
    group: "Forms for Pair day",
    name: "Forms for Pair day: on/off and rollout",
    risk: "caution",
    description: "То же для обычного «дня пары»; платная линза форм не использует; сид выкл.",
    fineTuning: false,
  },
  {
    key: "transit_day_form",
    kind: "llm",
    screen: "forms",
    group: "Forms glue AI",
    name: "Forms glue AI: Daily transit",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. «Клей» режима форм: модель вставляет детали; копия настроек Daily transit, t=0.5; выключить строку значит режим форм выкл для всех языков.",
    fineTuning: true,
  },
  {
    key: "partner_day_form",
    kind: "llm",
    screen: "forms",
    group: "Forms glue AI",
    name: "Forms glue AI: Pair day",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. То же для Pair day; копия настроек Pair day, t=0.5; выключить строку значит режим форм выкл для всех языков.",
    fineTuning: true,
  },
  {
    key: "form_candidates_per_slot",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: candidates per slot",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Сколько форм-кандидатов на слот; сид 2; меняет разнообразие.",
    fineTuning: true,
  },
  {
    key: "form_min_candidates",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: minimum candidates",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Когда ослабляется отбор; сид 3; меняет разнообразие.",
    fineTuning: true,
  },
  {
    key: "form_no_repeat_days",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: no-repeat days",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Дней без повтора формы; сид 14; меняет разнообразие.",
    fineTuning: true,
  },
  {
    key: "form_fidelity_min",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: template fidelity",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Доля слов шаблона, которую обязана сохранить модель; сид 0.9 (0.5..1.0); ниже значит модель вольнее; пишется только в журнал.",
    fineTuning: true,
  },
  {
    key: "form_min_active_per_locale",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: min active forms per language",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Порог отката на ИИ; сид 150; выше значит чаще ИИ (дороже); 0 порог выкл.",
    fineTuning: true,
  },
  {
    key: "form_min_slots_filled",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: min filled slots",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Порог отката на ИИ; сид 6; выше значит чаще ИИ (дороже); 0 порог выкл.",
    fineTuning: true,
  },
  {
    key: "form_min_per_relation",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: min forms per Relation level",
    risk: "caution",
    description:
      "Fine-tuning, usually leave as is. Порог отката на ИИ; сид 25; выше значит чаще ИИ (дороже); 0 порог выкл.",
    fineTuning: true,
  },
  {
    key: "form_banned_terms",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: banned words",
    risk: "caution",
    description:
      "Запрещённые слова по языкам (до 500 на язык); строки на экране нет, дефолт в коде, сида нет; пока строку не создадут, экран о настройке не знает.",
    fineTuning: false,
  },
  {
    key: "stylegen_base_url",
    kind: "dial",
    screen: "forms",
    group: "Forms",
    name: "Forms: import service address",
    risk: "none",
    description:
      "Fine-tuning, usually leave as is. Адрес стороннего сервиса форм для разового импорта; сид пусто; влияет только на скрипт.",
    fineTuning: true,
  },
  {
    key: "admin_web_login",
    kind: "dial",
    screen: "service",
    group: "Admin sign-in via browser",
    name: "Admin sign-in via browser: on/off",
    risk: "danger",
    description:
      "Выключатель входа в админку через браузер; вкл; выкл значит в браузерную админку не войти.",
    fineTuning: false,
  },
  {
    key: "worker_daily_transits",
    kind: "dial",
    screen: "service",
    group: "Background job",
    name: "Background job: Daily transits",
    risk: "danger",
    description:
      "Выключатель фоновой задачи дневных транзитов; вкл; выкл значит задача пропускается, правила игнорируются.",
    fineTuning: false,
  },
  {
    key: "worker_analytics_rollup",
    kind: "dial",
    screen: "service",
    group: "Background job",
    name: "Background job: analytics summary",
    risk: "caution",
    description: "Выключатель фоновой сводки аналитики; вкл; выкл значит панели не обновляются.",
    fineTuning: false,
  },
  {
    key: "push_auto_prompt",
    kind: "dial",
    screen: "service",
    group: "Push permission",
    name: "Push permission: ask automatically",
    risk: "caution",
    description:
      "Автозапрос пушей после первого натала; вкл; выкл значит остаётся ручной переключатель в профиле.",
    fineTuning: false,
  },
  {
    key: "appstore_sandbox_grants",
    kind: "dial",
    screen: "service",
    group: "Count Sandbox and TestFlight purchases",
    name: "Count Sandbox and TestFlight purchases",
    risk: "caution",
    description:
      "Засчитывать покупки Sandbox и TestFlight; вкл; выкл значит ответ 422, тестеры не смогут покупать.",
    fineTuning: false,
  },
] as const satisfies readonly SettingEntry[];
